/**
 * ledgerPeriodKey
 *
 * The key of one fiscal period: its local start date, `YYYY-MM-DD`, in the structure's zone the
 * period was computed in, so August 2026 in Chicago is `2026-08-01`. The key is the `periodKey` of a
 * close's id `close:{periodKey}:{closeNumber}` and of `correctsPeriod`, so it must stay stable once
 * persisted. Throws on an invalid `startAt`. Consumers: `ledgerPeriodOfKey`, `ledgerDuePeriods`,
 * `ledgerPeriodCloseTransaction`, `ledgerPlaceTransactions` and the period close callables.
 */

import type { LedgerPeriod } from './LedgerPeriod.types';

function ledgerPeriodKey(period: LedgerPeriod): string {
    const key = period.startAt.toISODate();
    if (key === null) throw new Error(`ledgerPeriodKey: period ${period.index} has an invalid startAt`);
    return key;
}

export { ledgerPeriodKey };
